namespace RioERP.Users {
    export interface VendorsForm {
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        BankAccountType: Serenity.EnumEditor;
        BankAccountName: Serenity.StringEditor;
        BankAccountNo: Serenity.StringEditor;
        BankIfscCode: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Country: Serenity.StringEditor;
        Gstin: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        GstCertificate: Serenity.MultipleImageUploadEditor;
        Pincode: Serenity.IntegerEditor;
        Email: Serenity.EmailEditor;
    }

    export class VendorsForm extends Serenity.PrefixedContext {
        static formKey = 'Users.Vendors';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VendorsForm.init)  {
                VendorsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.MultipleImageUploadEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.EmailEditor;

                Q.initFormType(VendorsForm, [
                    'Name', w0,
                    'Description', w0,
                    'BankName', w0,
                    'BankAccountType', w1,
                    'BankAccountName', w0,
                    'BankAccountNo', w0,
                    'BankIfscCode', w0,
                    'Address', w0,
                    'City', w0,
                    'StateId', w2,
                    'Country', w0,
                    'Gstin', w0,
                    'Pan', w0,
                    'GstCertificate', w3,
                    'Pincode', w4,
                    'Email', w5
                ]);
            }
        }
    }
}
